import store from '../../redux/reducers';
import { setScreen, setConfiguration } from '../../redux/actions';
import parseVendorConsent from './parseVendorConsent';

const switchScreenButton = async configuration => {
    const currentState = store.getState();

    if (!configuration.consentGiven) {
        let config = {...configuration}
        config.defaultConsent = false;
        config.defaultObjectConsent = false;
        const consent = parseVendorConsent(config);
        config.vendorConsent = consent.vendorConsent;
        config.objectConsent = consent.objectConsent;
        config.purposeConsent = consent.purposeConsent;
        config.purposeLegitimateInterest = consent.purposeLegitimateInterest;
        config.specialFeatureOptins = consent.specialFeatureOptins;


        store.dispatch(setConfiguration(config, currentState.currentLanguage.code));
    }

    store.dispatch(setScreen(2));
}

export {
    switchScreenButton
}